import './MobileApp.scss';
import AppPreviewOne from '../../../../assets/settings/app-preview-1.png';
import AppPreviewTwo from '../../../../assets/settings/app-preview-2.png';
import AppStore from '../../../../assets/settings/appstore.png';
import PlayStore from '../../../../assets/settings/playstore.png';
import { useTranslation } from 'react-i18next';

const MobileApp = () => {
  const { t } = useTranslation();

  return (
    <div className="mobile-app-container">
      <p className="mobile-app-title">{t('settings.productHub.mobileApp')}</p>
      <p className="mobile-app-subtitle">{t('settings.productHub.expandExperience')}</p>
      <div className="mobile-app">
        <div className="app-previews">
          <img
            src={AppPreviewOne}
            alt={t('settings.productHub.appPreviewOneAlt')}
            draggable="false"
          />
          <img
            src={AppPreviewTwo}
            alt={t('settings.productHub.appPreviewTwoAlt')}
            draggable="false"
          />
        </div>
        <div className="store-links">
          <a
            href="https://apps.apple.com/us/app/lifestack-calendar-and-health/id6473464429"
            target="_blank"
          >
            <img src={AppStore} alt={t('settings.productHub.appStoreAlt')} draggable="false" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.demind.lifestack_calendar&hl=en_US&gl=US"
            target="_blank"
          >
            <img src={PlayStore} alt={t('settings.productHub.playStoreAlt')} draggable="false" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileApp;
